import { getCCWeeklyReport } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';
import { useFormik } from 'formik';
import {
	WEEKLY_THURSDAY_WEDNESDAY_PERIODS_OF_TIME_OPTIONS,
	DEFAULT_WEEKS_BACK,
} from '../constants/timePeriod';

const useCCWeeklyReport = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [data, setData] = useState();

	const formik = useFormik({
		initialValues: {
			time_period: WEEKLY_THURSDAY_WEDNESDAY_PERIODS_OF_TIME_OPTIONS,
			period_from:
				WEEKLY_THURSDAY_WEDNESDAY_PERIODS_OF_TIME_OPTIONS.period_date_from[
					DEFAULT_WEEKS_BACK
				],
			period_to:
				WEEKLY_THURSDAY_WEDNESDAY_PERIODS_OF_TIME_OPTIONS.period_date_to[0],
			market: null,
			product: null,
		},
		onSubmit: (values) => handleSubmit(values),
	});

	const isLoading = hasUnfilledRequest(getCCWeeklyReport);

	const fetchCCWeeklyReportData = async (
		dateFrom,
		dateTo,
		marketId,
		productId,
	) => {
		const payload = {
			period_from: dateFrom,
			period_to: dateTo,
			market_id: marketId,
			product_id: productId,
		};

		const response = await makeRequest(getCCWeeklyReport.bind(null, payload));

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}
		setData(response.data);
	};

	const handleSubmit = (values) => {
		const dateFrom = values.period_from.label;
		const dateTo = values.period_to.label;
		const marketId = values.market.value;
		const productId = values.product?.value;
		fetchCCWeeklyReportData(dateFrom, dateTo, marketId, productId);
	};

	return {
		fetchCCWeeklyReportData,
		isLoading,
		data,
		formik,
	};
};

export default useCCWeeklyReport;
